exports.iframeResizer = require('./iframeResizer');
exports.iframeResizerContentWindow = require('./iframeResizer.contentWindow');



//////////////////
// WEBPACK FOOTER
// ./node_modules/iframe-resizer/js/index.js
// module id = 370
// module chunks = 0